import { Controller } from "@hotwired/stimulus"

// Syncs the master "All employees" checkbox with per-role checkboxes.
// Submitted audience is only survey_request[roles][] — the master is UI-only.
export default class extends Controller {
  static targets = ["all", "item"]

  connect() {
    this.syncAll()
  }

  toggleAll() {
    const checked = this.allTarget.checked

    this.itemTargets.forEach((checkbox) => {
      checkbox.checked = checked
    })
  }

  syncAll() {
    if (!this.hasAllTarget) return

    const items = this.itemTargets
    if (items.length === 0) return

    this.allTarget.checked = items.every((checkbox) => checkbox.checked)
  }
}
